import _ from 'lodash';
import { lsApiService } from 'ls-vue-common';
import {
    FEATURE_FLAGS__MUTATE_FLAGS,
    FEATURE_FLAGS__GET_FLAGS,
    FEATURE_FLAGS__REGISTER_EXPOSURE,
    FEATURE_FLAGS__ALL_FLAGS,
    ERROR__SET_ERROR,
} from '../types';

const createInitialState = () => ({
    flags: {},
});

export const mutations = {
    [FEATURE_FLAGS__MUTATE_FLAGS](state, payload) {
        _.assign(state.flags, payload);
    },
};

export const actions = {
    [FEATURE_FLAGS__GET_FLAGS]({ commit, dispatch }) {
        return lsApiService
            .request({
                route: '/flags',
            })
            .then(({ data }) => {
                commit(FEATURE_FLAGS__MUTATE_FLAGS, data);
            })
            .catch((error) => {
                dispatch(ERROR__SET_ERROR, error);
            });
    },

    [FEATURE_FLAGS__REGISTER_EXPOSURE]({ dispatch, state }, { flag }) {
        if (_.isNull(_.get(state.flags, `${flag}`, null))) {
            return;
        }

        // eslint-disable-next-line consistent-return
        return lsApiService
            .request({
                route: `/flags/${flag}`,
            })
            .catch((error) => {
                dispatch(ERROR__SET_ERROR, error);
            });
    },
};

export const getters = {
    [FEATURE_FLAGS__ALL_FLAGS](state) {
        return state.flags;
    },
};

export const featureFlags = {
    state: createInitialState,
    mutations,
    actions,
    getters,
};
